/**
 * Российские мобильные номера: маска ввода и нормализация.
 * Внешний API хранит номер как 7XXXXXXXXXX.
 */

/** 10 цифр номера без кода страны; ввод с 8 или 7 в начале тоже понимаем. */
function nationalDigits(value: string): string {
  let digits = (value || '').replace(/\D+/g, '');
  // +7 / 8 в начале — код страны, дальше национальный номер
  if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
}

/** 10 цифр → «+7 900 000-00-00», частичный ввод — без висящих разделителей. */
function formatNational(d: string): string {
  if (d.length === 0) return '+7 ';
  let out = '+7 ' + d.slice(0, 3);
  if (d.length > 3) out += ' ' + d.slice(3, 6);
  if (d.length > 6) out += '-' + d.slice(6, 8);
  if (d.length > 8) out += '-' + d.slice(8, 10);
  return out;
}

/**
 * Маска поля телефона: «+7 900 000-00-00».
 * Передайте прошлое значение поля — тогда Backspace сразу за разделителем
 * удалит цифру, а не упрётся в пробел или дефис.
 */
export function maskPhoneInput(value: string, previous = ''): string {
  if (!value || !/\d/.test(value)) {
    return '';
  }

  let digits = nationalDigits(value);
  const deleting = previous !== '' && value.length < previous.length;

  // Стёрли только разделитель — значит, хотели стереть цифру перед ним
  if (deleting && digits === nationalDigits(previous)) {
    digits = digits.slice(0, -1);
  }

  // Стёрли все цифры — очищаем поле целиком, иначе «+7 » не удалить
  if (deleting && digits.length === 0) {
    return '';
  }

  // Ввели только код страны (7 или 8) — показываем «+7 », чтобы нажатие не «пропало»
  return formatNational(digits);
}

/** Любой ввод (+7…, 8…, со скобками) → 7XXXXXXXXXX; null — номер неполный или неверный. */
export function normalizePhone(raw: string): string | null {
  let digits = (raw || '').replace(/\D+/g, '');
  if (digits.length === 11 && digits[0] === '8') digits = '7' + digits.slice(1);
  if (digits.length === 10) digits = '7' + digits;
  if (digits.length !== 11 || digits[0] !== '7') return null;
  return digits;
}

/** 79000000000 → +7 900 000-00-00; некорректное значение возвращается как есть. */
export function formatPhone(raw: string): string {
  const d = normalizePhone(raw);
  if (!d) return raw || '—';
  return formatNational(d.slice(1));
}

export const PHONE_PLACEHOLDER = '+7 900 000-00-00';
